import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AddProviderModal } from '@/components/provider-directory/AddProviderModal';
import { useMatter } from '@/hooks/useMatter';
import { useGetIncidentsQuery } from '@/services/api/incidentService';

export const CreateProviderPageV2 = () => {
  const { matterId } = useMatter();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const { data: incidents } = useGetIncidentsQuery(
    { matterId },
    { skip: !isOpen },
  );

  const incidentCenter = useMemo(() => {
    const list = incidents ?? [];
    const best =
      list.find(
        (i) =>
          i.normalized_location?.latitude != null &&
          i.normalized_location?.longitude != null,
      ) ??
      list.find(
        (i) => i.extracted_latitude != null && i.extracted_longitude != null,
      );
    if (!best) return null;
    const lat = best.normalized_location?.latitude ?? best.extracted_latitude;
    const lng = best.normalized_location?.longitude ?? best.extracted_longitude;
    if (lat == null || lng == null) return null;
    return { lat, lng };
  }, [incidents]);

  if (!matterId) return null;

  return (
    <div className="h-full">
      <AddProviderModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          navigate(`/matters/${matterId}/treatment`);
        }}
        matterId={matterId}
        centerLat={incidentCenter?.lat}
        centerLng={incidentCenter?.lng}
        onProviderCreated={(medicalProviderId) => {
          setIsOpen(false);
          navigate(`/matters/${matterId}/treatment/${medicalProviderId}`);
        }}
      />
    </div>
  );
};
